import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountableFunctionDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { AccountablefunctionComponent } from '../pipelinedetails/accountablefunction/accountablefunction.component';
import { PipelineGenericFacade } from '../../states/+pipeline-generic/pipeline-generic.facade';


@Component({
  selector: 'cradua-accountablefxnpopup',
  templateUrl: './accountablefxnpopup.component.html',
  styleUrls: ['./accountablefxnpopup.component.scss']
})
export class AccountablefxnpopupComponent implements OnInit {


  accountablefunctionForm: FormGroup;
  accountablefunctionFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() accountablefunction = new EventEmitter<AccountableFunctionDto[]>()
  @Output() deleteAccountableFunctionEvent = new EventEmitter<any>()

  filteredAccountableFunction: Array<any> = [];
  selectedAccountableFunctionId: any;
    selectedAccountableFunction: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    AcctFxnList: any[]=[];
    acountablefunctionlink2s: any[];

    constructor(private fb: FormBuilder, public matdialogue: MatDialogRef<AccountablefunctionComponent>,
      public pipelineGenericFacade: PipelineGenericFacade, @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit() {
      this.pipelineGenericFacade.loadGatewayById("AccountableFunctionLink2").subscribe(pipeline => {
        this.acountablefunctionlink2s = pipeline;
      });
      this.filteredAccountableFunction = this.data;
      this.createAccountableFunctionForm();
    }

    checkSelected(AccountableFunctionName) {
      const check =  this.acountablefunctionlink2s.find(a => a.AccountableFunctionName === AccountableFunctionName);
      return check ? true : false;
    }

    createAccountableFunctionForm() {
      this.accountablefunctionForm = this.fb.group({
        AccountableFunctionName: ['', Validators.required],
        FunctionId: [''],
        FunctionName: [''],
        FunctionalEmail: [''],
        AutoSerialId: [''],
        SubscriberId: [''],
        SubscriptionUserId: [''],
        id: null
        });
        this.accountablefunctionFormArray = this.fb.group({ AccountableFunctions: this.fb.array([])
          });
        this.setAccountableFunction();
    }

  // method to display accountablefunctions
  setAccountableFunction() {
    const control  = this.accountablefunctionFormArray.controls.AccountableFunctions as FormArray;
    this.filteredAccountableFunction.forEach( e => {

      control.push(
        this.fb.group({
          AccountableFunctionName: e.AccountableFunctionName,
          FunctionId: e.FunctionId,
          FunctionName: e.FunctionName,
          FunctionalEmail: e.FunctionalEmail,
          AutoSerialId: e.AutoSerialId,
          SubscriberId: e.SubscriberId,
          SubscriptionUserId: e.SubscriptionUserId,
          // id: e.id
        })
      );
    });
  }

  // method to add AccountableFunction
  addAccountableFunction(value: AccountableFunctionDto) {
    const control  = this.accountablefunctionFormArray.controls.AccountableFunctions as FormArray;
    control.insert(0,
          this.fb.group({
            AccountableFunctionName: value.AccountableFunctionName,
            FunctionId: value.FunctionId,
            FunctionalEmail: value.FunctionalEmail,
            id: null
          })
       );
  }

  addNew(formValue: AccountableFunctionDto) {
    if(this.accountablefunctionForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.accountablefunctionFormArray.get('AccountableFunctions')['controls'][this.selectedIndex].patchValue({AccountableFunctionName: formValue.AccountableFunctionName, FunctionalEmail: formValue.FunctionalEmail});
    } else {
      this.addAccountableFunction(formValue);
    }
    this.selectedIndex = null;
    this.accountablefunctionForm.reset()
  }

  selectAccountableFxn(event: string) {
    let name;
    if(event.length > 0) {
      name = event.toLowerCase();
    }
  
    this.filteredAccountableFunction = this.data.filter((s) => s.AccountableFunctionName.toLowerCase().includes(name));

    const control = this.accountablefunctionFormArray.controls.AccountableFunctions as FormArray;
  
    if (this.filteredAccountableFunction.length > 0) {
      this.clearFormArray(control);
      this.setAccountableFunction();
    } else {
      this.clearFormArray(control);
      // this.filteredAccountableFunction = this.data;
      this.setAccountableFunction();
    }
  }

  clearFormArray = (formArray: FormArray) => {
    const control = this.accountablefunctionFormArray.controls.AccountableFunctions as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  onEdit(index, value: AccountableFunctionDto) {
    
    this.selectedIndex = index;
  }

  getFuntionName(id) {
    // return this.data.event1.find(e => e.id === id);
  }

  onClearForm() {
    this.selectedIndex = null;
    this.accountablefunctionForm.reset();
  }

  onClose() {
    this.matdialogue.close();
  }

  checkAccountableFunction(value) {
    this.AcctFxnList.unshift(value);
  }

  onSubmit() {
    this.matdialogue.close(this.AcctFxnList)
  }

}
